import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';

export const RootErrorBoundary = () => {
  const { t } = useTranslation();
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-4xl font-bold">{t('default:navigator.sorry')}</h1>
      <p className="text-lg">{t('default:navigator.noWorries')}</p>
    </div>
  );
};
